<template>
  <div>
    <table cellpadding="10" cellspacing="0" width="95%" class="hover-table invoices-table" align="center">
      <thead>
        <tr v-if="!pending">
          <td valign="middle">
            <strong>{{ $t("noCrtLabel") }}</strong>
          </td>
          <td @click="() => (sortByField = 'order_date')" valign="middle">
            <strong>{{ $t("ordersTableHeaderDate") }}</strong>&nbsp;
            <img v-if="!dashboard" src="@/assets/images/arrow-down-fill.svg" @click="sortBy('order_date')" :style="
              sortByField === 'order_date' &&
              reverse &&
              'transform: rotate(180deg)'
            " />
          </td>
          <td @click="() => (sortByField = 'h.orderid')" valign="middle">
            <strong>{{ $t("ordersTableHeaderNumber") }}</strong>&nbsp;
            <img v-if="!dashboard" src="@/assets/images/arrow-down-fill.svg" @click="sortBy('h.orderid')" :style="
              sortByField === 'h.orderid' &&
              reverse &&
              'transform: rotate(180deg)'
            " />
          </td>
          <td class="priority-3" @click="() => (sortByField = 'CODPROD')" valign="middle">
            <strong>{{ $t("ordersTableHeaderProduct") }}</strong>&nbsp;
            <img v-if="!dashboard" src="@/assets/images/arrow-down-fill.svg" @click="sortBy('CODPROD')" :style="
              sortByField === 'CODPROD' &&
              reverse &&
              'transform: rotate(180deg)'
            " />
          </td>
          <td class="priority-4" valign="middle">
            <strong>{{ $t("ordersTableHeaderType") }}</strong>
            &nbsp;
          </td>
          <td class="priority-2" @click="() => (sortByField = 'totamtdue')" valign="middle">
            <strong>{{ $t("ordersTableHeaderAmount") }}</strong>&nbsp;
            <img v-if="!dashboard" src="@/assets/images/arrow-down-fill.svg" @click="sortBy('totamtdue')" :style="
              sortByField === 'totamtdue' &&
              reverse &&
              'transform: rotate(180deg)'
            " />
          </td>
          <td class="priority-5" valign="middle">
            <strong>{{ $t("ordersTableHeaderStatus") }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" @click="sortBy('ordstatus')" :style="
              sortByField === 'ordstatus' &&
              reverse &&
              'transform: rotate(180deg)'
            " />
          </td>
          <!-- <td class="priority-5" valign="middle" width="18%">
            <strong>{{ $t("ordersTableHeaderTrack") }}</strong>&nbsp;
          </td> -->
          <!-- <td valign="middle">
            <strong>{{ $t("beneficiaryOrderHistory") }}</strong>
          </td>-->
          <td valign="middle" v-if="!dashboard">&nbsp;</td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="this.companyOrders === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <template v-for="(order, index) in companyOrders">
          <tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
            <td valign="middle">
              <a @click="selectOrderMobile(index)" class="detailsOrderMobile priority-show-5 display-inline-block">
                <font-awesome-icon icon="minus-circle" v-if="detailsMobile && order === selectedOrder" />
                <font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
              </a>
              <span class="crt">{{ index + 1 }}</span>
            </td>
            <td valign="middle">{{ displayDate(order.date) }}</td>
            <td valign="middle">
              {{ order.type === "REPL" ? $t("replacementLabel") : order.id }}
            </td>
            <td valign="middle" class="priority-3">
              <img :src="
                require('@/assets/images/bullet_' + order.product + '.svg')
              " />
              &nbsp;&nbsp;{{ getProductNameMethod(order.product, order.brand) }}
            </td>
            <td valign="middle" class="priority-4">
              <img :src="
                require('@/assets/images/product_' + order.product + '.svg')
              " />
            </td>
            <td valign="middle" class="priority-2">
              <span>
                {{ order.total_nominal_value | toCurrency }}
              </span>
            </td>
            <td valign="middle" class="priority-5">
              <span class="status-background" :class="selectColorStatus(order.status)">
                {{
                  $t(
                    "orderStatus_" +
                    (order.status.length > 2 ? "V2" : order.status)
                  )
                }}
              </span>
            </td>
            <td valign="middle" v-if="!dashboard">
              <a v-if="
                pending &&
                (order.status === 'P' || order.status === 'N') &&
                order.type !== 'REPL'
              " href="#" class="notification-action color-blue padding-5" @click="payorder(order, '')">{{
  $t("paymentButtonLabel") }}
              </a>&nbsp;&nbsp;
              <a v-if="
                pending &&
                (order.status === 'P' || order.status === 'N') &&
                order.type !== 'REPL'
              " href="#" class="notification-action color-blue padding-5" @click="payorder(order, 'later')">{{
  $t("ordersButtonLabel") }}
              </a>
              <a v-if=" pending && order.status === 'R' && onlyForAdmin(userRole)" href="#" class="notification-action color-blue padding-5" 
              @click="confirmOrder(order)">{{
  $t("confirmButtonLabel") }}
              </a>
            </td>
            <td valign="middle" v-if="!dashboard ">
              <a v-if = "order.muorderid > 0" class="notification-action nocase color-darkblue padding-5" @click="
                openAWB(
                  'https://www.easymail.gr/index.php/web-tracking?UP' + order.muorderid );
              " target="_blank">
                <!-- <font-awesome-icon icon="truck" size="2x" /> -->
                {{ $t("ordersTableHeaderTrack") }}

                <!-- <img class="track-trace" src="@/assets/images/tracktrace.svg" /> -->
              </a>
            </td>
            <td valign="middle" v-if="!dashboard">

              <!-- v-if="
                  (!duplicate &&
                    (order.status === 'P' || order.status === 'PV')) ||
                  order.status === 'N'
                " -->
              <a class="see-more" v-if="(order.type !== 'REPL' &&
                order.status === 'P' || order.status === 'PV' ||
                order.status === 'N')
              " @click="selectOrderAction(order, 'cancel')">
                <font-awesome-icon icon="trash-alt" size="2x" />
              </a>
              &nbsp;&nbsp;
              <a class="see-more" @click="selectOrderAction(order, 'details')">
                <font-awesome-icon icon="arrow-alt-circle-right" size="2x" />
              </a>

              <!-- <a href="#" class="action-button" @click="selectOrderAction(order, 'AWB')">Track AWB</a> -->
            </td>
          </tr>
          <tr :key="index + companyOrders.length" class="child" :class="index % 2 === 0 && 'gri-cell'"
            v-show="detailsMobile && order === selectedOrder">
            <td colspan="12">
              <p class="priority-show-3">
                <strong>{{ $t("ordersTableHeaderProduct") }} : &nbsp;&nbsp;</strong>
                <span>
                  <img class="product-png" :src="
                    require('@/assets/images/bullet_' +
                      order.product +
                      '.svg')
                  " />
                  &nbsp;&nbsp;{{
                    getProductNameMethod(order.product, order.brand)
                  }}
                </span>
              </p>
              <p class="priority-show-4">
                <strong>{{ $t("ordersTableHeaderType") }} : &nbsp;&nbsp;</strong>
                <span>
                  <img :src="
                    require('@/assets/images/product_' +
                      order.product +
                      '.svg')
                  " />
                </span>
              </p>
              <p class="priority-show-2">
                <strong>{{ $t("ordersTableHeaderAmount") }} : &nbsp;&nbsp;</strong>
                <span>
                  {{ order.total_nominal_value | toCurrency }}
                </span>
              </p>
              <p class="priority-show-5">
                <strong>{{ $t("ordersTableHeaderStatus") }} : &nbsp;&nbsp;</strong>
                <span class="status-background" :class="selectColorStatus(order.status)">
                  {{
                    $t(
                      "orderStatus_" +
                      (order.status.length > 2 ? "V2" : order.status)
                    )
                  }}
                </span>
              </p>
              <!-- <p class="priority-show-4">
                <strong>{{ $t("ordersTableHeaderInvoice") }} : &nbsp;&nbsp;</strong>
              </p>-->
              <!-- <p class="priority-show-5">
                <strong>{{ $t("beneficiaryOrderHistory") }} : &nbsp;&nbsp;</strong>
                <span>
                  <a href="#" class="invoice-icon">&nbsp;</a>
                </span>
              </p>-->
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import products from "@/assets/json/products.js";
import utils from "@/plugins/utils.js";
import moment from "moment";

export default {
  name: "OrdersTableDesktop",
  props: {
    companyOrders: Array,
    company: Object,  
    pending: Boolean,
    dashboard: Boolean,
    duplicate: Boolean,
    height: Number,
    msg: String,
    userRole: String,
  },
  data() {
    return {
      detailsMobile: false,
      sortByField: "order_date",
      selectedOrder: null,
      reverse: false,
    };
  },
  methods: {
    downloadOrder() { },
    sortBy(fieldName) {
      if (this.sortByField !== fieldName) {
        this.reverse = false;
      }
      this.sortByField = fieldName;
      this.reverse = !this.reverse;
      this.$emit(
        "change",
        fieldName,
        this.reverse ? "asc" : "desc",
        this.pending
      );
    },
    selectOrderMobile(index) {
      if (
        this.selectedOrder !== null &&
        this.selectedOrder.number !== this.companyOrders[index].number
      ) {
        this.detailsMobile = !this.detailsMobile;
      }
      this.selectedOrder = this.companyOrders[index];
      this.detailsMobile = !this.detailsMobile;
    },
    selectOrderAction(order, action) {
      this.$emit("click", order, action);
    },
    getProductNameMethod(product, brand) {
      return utils.getProductByIdAndBrand(product, brand, products).name;
    },
    selectColorStatus(status) {
      return utils.selectColorStatus(status.length > 2 ? "V2" : status);
    },
    displayDate(date) {
      // moment.setLocale("ro");
      return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format("DD/MM/YYYY");
    },
    openAWB(url) {
      window.open(url, "_blank");
    },
    payorder(order, later) {
      this.$emit("click", order, "pay" + later);
    },
    confirmOrder(order){
      // utils.openWindowWithPost('localhost:8080/customer/new_order', order);
      this.$store.state.customerDataLoaded = false;
      this.$router.push({
					name: "customer_new_order",
					params: {order: order},
				});
    }   
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
.padding-5 {
  padding: 5px !important;
}

.track-trace {
  height: 35px;
  align-items: center;
}

.color-blue {
  background: #009bf4 !important;
}

.color-darkblue {
  background: darkblue !important;
}

.nocase {
  text-transform: none !important;
}

@media (max-width: 768px) {
  .orders-page .invoices-filter .vue-daterange-picker {
    width: auto;
  }
}
</style>
